import type { PostponeTimeErrorCode } from './types';

export const TIME_POSTPONEMENT_CONDITIONS = [
  'สามารถเลื่อนเวลาได้เฉพาะก่อนเริ่มการสอบเท่านั้น',
  'เวลาสอบใหม่ต้องสิ้นสุดไม่เกิน 23:59 น. ของวันสอบ',
];

export const errorMapping: Record<PostponeTimeErrorCode, string> = {
  EXAM_SESSION_ALREADY_STARTED: 'ไม่สามารถเลื่อนเวลาสอบได้ เนื่องจากช่วงสอบเริ่มแล้ว',
  EXAM_EVENT_POSTPONE_ALREADY_UPDATED: 'ไม่สามารถเลื่อนเวลาสอบได้ เนื่องจากเวลาสอบถูกเลื่อนไปแล้ว',
  EXAM_SESSION_END_TIME_EXCEEDS_MIDNIGHT:
    'ไม่สามารถเลื่อนเวลาได้ เนื่องจากเวลาสิ้นสุดต้องไม่เกิน 23:59 น. ของวันสอบ',
};
